import { money, number } from '../../util/formatters'
import React from 'react'
import { Calculation } from './Calculation'
import { get, getSuffix } from '../../util/kdp_cols'
import { MarketplaceI } from '../../util/marketplaces'

interface CpcCellProps {
    cpc: number
    cost: number
    clicks: number
    marketplace?: MarketplaceI
}

export const CpcCell = (v: CpcCellProps, extra: any) => {
    const suffix = getSuffix(extra.col?.key)
    const g = (key: string) => get(v, key, suffix)
    const m = v.marketplace ?? null

    const lines = [
        { description: 'Spend', value: money(g('cost'), m) ?? '' },
        { description: '÷ Clicks', value: number(g('clicks'), 0) ?? '' },
        { description: 'CPC', value: money(g('cpc'), m) ?? '' },
    ]

    return <Calculation lines={lines}>{money(g('cpc'), m)}</Calculation>
}
